import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section className="border-b border-line bg-panel py-20 sm:py-24" data-id="element-189" data-mp="2ltmglpx0jlk0">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16" data-id="element-190" data-mp="30hhctga8c81u">
        <div data-id="element-191" data-mp="2vq7msekrr2pf">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-192" data-mp="2vppkp1bfdu9l">
            The reality of running an academy
          </p>
          <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl" data-id="element-193" data-mp="35gat1ggwid5p">
            Is your academy growing, or is it just surviving?
          </h2>
          <p className="mt-6 font-display text-2xl font-bold uppercase tracking-tight text-white/45 sm:text-3xl" data-id="element-194" data-mp="3egz3k1735vdu">
            How much longer are you willing to improvise?
          </p>
        </div>

        <ul className="divide-y divide-line border-y border-line" data-id="element-195" data-mp="1k2y0130lck7f">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 py-5" data-id="element-196" data-mp="jddb84xia6ty">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-white/25" aria-hidden="true" data-id="element-197" data-mp="jbadszu0xbf7" />
              <p className="text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-198" data-mp="sdjnxoldr2s2">
                {problem}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}